import { render, staticRenderFns } from "./VeGiaoThongList.vue?vue&type=template&id=48b55345"
import script from "./VeGiaoThongList.vue?vue&type=script&lang=js"
export * from "./VeGiaoThongList.vue?vue&type=script&lang=js"
import style0 from "./VeGiaoThongList.vue?vue&type=style&index=0&id=48b55345&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports